/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
import React, { Fragment, forwardRef } from 'react';

import 'moment/locale/pt-br';

import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';

import { useAuth } from '../../../hooks/auth';
import BRLMoneyFormat from '../../../utils/BRLMoneyFormat';

import stylesMaterial from './stylesMaterial';
import { Container, Complemento, TotalItem, Produto } from './styles';
import { IOrder } from '../../../interfaces/IOrder';
import { IDeliveryAddress } from '../../../interfaces/IDeliveryAddress';
import { IPaymentMethod } from '../../../interfaces/IPaymentMethod';
import { IOrderItem } from '../../../interfaces/IOrderItem';
import estagiosPedido from '../../../utils/estagiosPedido';

interface ComponentToPrintProps {
  pedido: Partial<IOrder> & {
    deliveryAddress?: Partial<IDeliveryAddress> | undefined;
    orderPayment: Partial<IPaymentMethod> & {
      companyPaymentMethod?: any;
    };
    items: Partial<IOrderItem>[];
  };
}

const ComponentToPrint = forwardRef<HTMLDivElement, ComponentToPrintProps>(
  (props, ref) => {
    const classes = stylesMaterial();
    const { pedido } = props;

    const { user } = useAuth();
    const moment = require('moment');

    return (
      <Container ref={ref}>
        <Typography className={classes.empresa}>
          {user.empresa_nome_fantasia}
        </Typography>

        <Typography className={classes.texto}>
          {`Funcionário: ${user.nome}`}
        </Typography>

        <Typography className={classes.texto}>
          Emissão: {moment(new Date(pedido.createdAt!)).format('LT | L')}
        </Typography>

        <Typography className={classes.texto}>
          {`Pedido: ${props.pedido.id}`}
        </Typography>

        {pedido.scheduledDeliveryAt && (
          <>
            <Divider className={classes.divider} />
            <Typography className={classes.texto}>
              {`Entrega programada para: ${moment(
                new Date(pedido.scheduledDeliveryAt),
              ).format('LT | L')}`}
            </Typography>
            <Divider className={classes.divider} />
          </>
        )}

        <Typography className={classes.tituloProdutos}>Produtos</Typography>

        <Divider className={classes.divider} />

        {pedido.items.map((item) => {
          return (
            <Fragment key={item.id}>
              <Produto>
                <Typography className={classes.productText}>
                  {`${
                    item.portioned
                      ? `${
                          item.quantity >= 1
                            ? Number(item.quantity).toFixed(3)
                            : item.quantity *
                              item.measurementUnit[0].quantityPortion
                        }${
                          item.quantity >= 1
                            ? item.measurementUnit[0].acronym
                            : item.measurementUnit[0].acronymPortion
                        }`
                      : Number(item.quantity)
                  }. `}
                  {!item.colorName && item.sizeName ? (
                    `Pizza ${String(item.sizeName).toLowerCase()}`
                  ) : item.colorName ? (
                    <>
                      {item.productName}
                      <p>
                        {item.productGridName}
                        {item.colorName && ` - ${item.colorName}`}
                      </p>
                    </>
                  ) : item.portioned &&
                    pedido.status === estagiosPedido.separacao ? (
                    `${item.productName} - Separar`
                  ) : (
                    item.productName
                  )}
                  {` (${Number(item.productPrice).toLocaleString(
                    'pt-BR',
                    BRLMoneyFormat,
                  )})`}
                </Typography>

                {!item.colorName && item.sizeName && (
                  <Typography
                    className={classes.productText}
                    style={{ whiteSpace: 'nowrap', paddingLeft: 40 }}
                  >
                    {Number(item.totalPrice).toLocaleString(
                      'pt-BR',
                      BRLMoneyFormat,
                    )}
                  </Typography>
                )}
              </Produto>

              {item.childOrderItems?.map((complemento) => {
                return (
                  <Complemento>
                    <Typography className={classes.nomeComplemento}>
                      <>
                        {Number(complemento.quantity)} {complemento.productName}
                      </>
                    </Typography>
                    <Typography
                      className={classes.precoComplemento}
                      style={{ whiteSpace: 'nowrap', paddingLeft: 40 }}
                    >
                      R${' '}
                      {complemento.totalPrice.toLocaleString(
                        'pt-BR',
                        BRLMoneyFormat,
                      )}
                    </Typography>
                  </Complemento>
                );
              })}
              {!!item.observation && (
                <Typography className={classes.texto}>
                  Obs: {item.observation}
                </Typography>
              )}
              <TotalItem>
                <Typography className={classes.texto}>Total:</Typography>
                <Typography
                  className={classes.totalItem}
                  style={{ whiteSpace: 'nowrap', paddingLeft: 40 }}
                >
                  {Number(item.totalPrice).toLocaleString(
                    'pt-BR',
                    BRLMoneyFormat,
                  )}
                </Typography>
              </TotalItem>
            </Fragment>
          );
        })}

        <Divider className={classes.divider} />

        <Typography className={classes.clienteInfo}>
          Cliente: {pedido?.customer?.tradingName ?? 'Venda balcão'}
        </Typography>

        {pedido.deliveryAddress ? (
          <Typography className={classes.clienteInfo}>
            Endereço:
            <br />
            {`${pedido.deliveryAddress.address.logradouro}, ${pedido.deliveryAddress.address.numero}, ${pedido.deliveryAddress.address.bairro}`}
            <br />
            {`${pedido.deliveryAddress.address.cidade}, ${pedido.deliveryAddress.address.estado}, ${pedido.deliveryAddress.address.cep}`}
            <br />
            Complemento:
            <br />
            {`${pedido.deliveryAddress.address.complemento}`}
          </Typography>
        ) : (
          <Typography className={classes.clienteInfo}>
            Entrega: Retirada balcão
          </Typography>
        )}

        {pedido?.customer && (
          <Typography className={classes.clienteInfo}>
            Telefone: {pedido.customer.phoneNumber}
          </Typography>
        )}

        {!!pedido.observation && (
          <>
            <Divider className={classes.divider} />

            <Typography className={classes.clienteInfo}>
              Observação: <br />
              {pedido.observation}
            </Typography>
          </>
        )}

        <Divider className={classes.divider} />

        <Typography className={classes.texto}>
          Forma de Pagamento:{' '}
          {pedido.orderPayment.companyPaymentMethod?.paymentMethod.description}
        </Typography>

        <Typography className={classes.texto}>
          Subtotal:{' '}
          {(+(pedido.itemsTotalPrice || 0)).toLocaleString(
            'pt-BR',
            BRLMoneyFormat,
          ) || ''}
        </Typography>

        {pedido.deliveryFee ? (
          <Typography className={classes.texto}>
            Taxa de entrega:{' '}
            {(+pedido.deliveryFee).toLocaleString('pt-BR', BRLMoneyFormat) ||
              ''}
          </Typography>
        ) : null}

        {pedido.discountCouponValue && +pedido.discountCouponValue ? (
          <Typography className={classes.texto}>
            Cupom desconto ({pedido.discountCoupon?.code}): R${' '}
            {(+pedido.discountCouponValue * -1).toLocaleString(
              'pt-BR',
              BRLMoneyFormat,
            ) || ''}
          </Typography>
        ) : (
          <div />
        )}

        {+(pedido.othersDiscountsValue || 0) ? (
          <Typography className={classes.texto}>
            Outros descontos:{' '}
            {(+(pedido.othersDiscountsValue || 0) * -1).toLocaleString(
              'pt-BR',
              BRLMoneyFormat,
            ) || ''}
          </Typography>
        ) : (
          <div />
        )}

        {pedido.orderPromotion?.length ? (
          <Typography className={classes.texto}>
            Promoções:{' '}
            {(
              pedido.orderPromotion.reduce((a, c) => a + +c.value, 0) * -1
            ).toLocaleString('pt-BR', BRLMoneyFormat)}
          </Typography>
        ) : null}

        <Typography className={classes.texto}>
          Total:{' '}
          {(+(pedido.total || 0)).toLocaleString('pt-BR', BRLMoneyFormat)}
        </Typography>

        {pedido.changeFor && +pedido.changeFor ? (
          <Typography className={classes.texto}>
            Troco:{' '}
            {(+(pedido.changeFor || 0)).toLocaleString('pt-BR', BRLMoneyFormat)}
          </Typography>
        ) : null}

        <Divider className={classes.divider} />

        {pedido.logisticDelivery ? (
          <>
            <Typography className={classes.texto}>
              Transportadora: {pedido.logisticDelivery.nome_transportadora}
            </Typography>
            <Typography className={classes.texto}>
              Serviço: {pedido.logisticDelivery.nome_servico_transportadora}
            </Typography>
            <Typography className={classes.texto}>
              Estimativa: {pedido.logisticDelivery.estimativa_tempo_entrega}{' '}
              dia(s)
            </Typography>
            <Divider className={classes.divider} />
          </>
        ) : null}
      </Container>
    );
  },
);

export default ComponentToPrint;
